(ns ui.components.drawer.zapkit-styles)

;; ----------------------------------------------------------------------------
;; AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
;; Regenerate via: scripts/convert_zapkit_json.bb <source>.json <output-dir-or-file>
;; (run from the project root directory).
;; Source: zapkit-components/src/components/Drawer/styles.json
;; Source commit: ab84e5aca876ac5a50d0da5ebe6ccba5349bbeeb
;; ----------------------------------------------------------------------------

(def drawer
  {:overlay
   {:base
    "tw2-inset-0 tw2-bg-modal-bg-overlay tw2-z-modal-overlay tw2-transition-opacity tw2-duration-200",
    :anchor {:viewport "tw2-fixed", :parent "tw2-absolute"},
    :visible {:true "tw2-opacity-modal-overlay", :false "tw2-opacity-0"},
    :compound-variants [],
    :default-variants {:anchor "viewport", :visible false}},
   :panel
   {:base
    "tw2-top-0 tw2-right-0 tw2-min-h-0 tw2-overflow-hidden tw2-bg-bg-secondary tw2-text-primary tw2-border-l tw2-border-drawer-border tw2-z-modal-overlay tw2-flex tw2-flex-col tw2-transform tw2-duration-200 tw2-ease-out",
    :placement
    {:overlay-viewport
     "tw2-fixed tw2-h-screen tw2-shadow-lg tw2-transition-transform",
     :overlay-parent
     "tw2-absolute tw2-h-full tw2-shadow-lg tw2-transition-transform",
     :inline
     "tw2-relative tw2-h-full tw2-shrink-0 tw2-transition-[width,max-width] tw2-duration-200 tw2-ease-out motion-reduce:tw2-transition-none"},
    :size
    {:sm "tw2-w-drawer-sm tw2-max-w-drawer-sm",
     :md "tw2-w-drawer-md tw2-max-w-drawer-md",
     :lg "tw2-w-drawer-lg tw2-max-w-drawer-lg",
     :full
     "tw2-w-[calc(100vw-var(--drawer-gutter))] tw2-max-w-[calc(100vw-var(--drawer-gutter))]"},
    :open {:true "tw2-translate-x-0", :false "tw2-translate-x-full"},
    :compound-variants [],
    :default-variants {}},
   :header
   {:base
    "tw2-sticky tw2-top-0 tw2-z-10 tw2-bg-bg-secondary tw2-border-b tw2-border-drawer-border tw2-p-4",
    :compound-variants [],
    :default-variants {}},
   :header-row
   {:base "tw2-flex tw2-items-center tw2-justify-between tw2-gap-4",
    :compound-variants [],
    :default-variants {}},
   :title
   {:base "tw2-text-heading-sm tw2-text-primary",
    :compound-variants [],
    :default-variants {}},
   :body
   {:base
    "tw2-min-h-0 tw2-flex-1 tw2-overflow-y-auto tw2-overflow-x-auto [overflow-wrap:anywhere] tw2-bg-bg-secondary tw2-p-4",
    :compound-variants [],
    :default-variants {}},
   :footer
   {:base
    "tw2-shrink-0 tw2-bg-bg-secondary tw2-border-t tw2-border-drawer-border tw2-p-4",
    :compound-variants [],
    :default-variants {}},
   :_meta
   {:tokens
    ["bg-secondary"
     "drawer-border"
     "drawer-width-lg"
     "drawer-width-md"
     "drawer-width-sm"
     "heading-sm-font-size"
     "heading-sm-font-weight"
     "heading-sm-line-height"
     "modal-bg-overlay"
     "opacity-modal-overlay"
     "text-primary"
     "z-modal-overlay"],
    :generated-from "src/components/Drawer/Drawer.styles.ts",
    :composes
    [{:slot "close", :component "iconButton", :variant "default"}],
    :runtime-styles
    [{:slot "panel",
      :property "width",
      :description
      "Inline and open: var(--drawer-width-sm|md|lg), or calc(100vw - var(--drawer-gutter)) for full, or the deprecated width. Inline and closed: 0px. Overlay with a deprecated width: that width. Omitted when an overlay uses the size scale."}
     {:slot "panel",
      :property "maxWidth",
      :description
      "Size scale: min(var(--drawer-width-sm|md|lg), calc(100vw - var(--drawer-gutter))), or the full gutter calc. Inline and closed: 0px. Inline and open with a deprecated width: that width. Omitted when an overlay sets a deprecated width."}
     {:slot "panel",
      :property "transition",
      :description
      "Inline only. width and max-width over 200ms ease-out, or none when prefers-reduced-motion."}
     {:slot "body",
      :property "overflow",
      :description
      "hidden on document.body while a viewport overlay with a backdrop is mounted; restored to the previous value when it closes. Not applied for inline or parent-anchored drawers."}],
    :a11y
    ["Overlay mode uses role=dialog, aria-modal=true, and tabIndex=-1."
     "Inline mode uses role=complementary and omits aria-modal. It does not move or trap focus."
     "When the default header shows a title, aria-labelledby points at that title and aria-label is omitted."
     "Overlay mode without a rendered title requires aria-label or aria-labelledby, so the dialog has a name."
     "The default close control is an IconButton named \"Close drawer\"."
     "On overlay open, focus moves to the first focusable element, or the panel."
     "Tab and Shift+Tab stay inside the overlay dialog while it is open."
     "On overlay close, focus returns to the element that was focused before opening."
     "A closed inline drawer sets inert while it is still mounted, then unmounts."
     "Escape closes when closeOnEsc is set. A backdrop click closes when the pointer went down on the overlay."]}})
